export default __webpack_public_path__ + "static/media/noun_Tree_16622.78a7831d.png";